import React, {
  useContext,
} from 'react';
import classNames from 'classnames';

import { useAppStore, useWindowStore } from '../../../stores';
import useConfigStore from '../../../stores/configStore';
import useMapStateStore from '../../../stores/mapStateStore';
import SiteSeeContext from '../../SiteSeeGuides/SiteSeeContext';
import { getPulseTarget, PULSE_TARGETS } from '../../SiteSeeGuides/SiteSeeGuideData';
import useSiteSeeModalDims from '../../SiteSeeGuides/useSiteSeeModalDims';

import MapControlsZoomMore from './MapControlsZoom/MapControlsZoomMore';
import MapControlsZoomLess from './MapControlsZoom/MapControlsZoomLess';
import MapControlsZoomReset from './MapControlsZoom/MapControlsZoomReset';
import MapControlsMapTypeToggle from './MapControlsMapTypeToggle/MapControlsMapTypeToggle';
import MapControlsPOIToggle from './MapControlsPOIToggle/MapControlsPOIToggle';
import MapControlsMarkersToggle from './MapControlsMarkersToggle/MapControlsMarkersToggle';
import ChatbotControl from './ChatbotControl/ChatbotControl';
import SiteSeeTipTrigger from '../../SiteSeeTipTrigger/SiteSeeTipTrigger';
import VectreInfo from '../../VectreInfo/VectreInfo';

import './MapControls.scss';

const MapControls = () => {
  const {
    siteSeeGuideId,
    siteSeeGuideMode,
  } = useContext(SiteSeeContext);

  const isMobile = useWindowStore((state) => state.isMobile);
  const platform = useAppStore((state) => state.settings?.platform);
  const enableTourGuideAI = useConfigStore((state) => state.config?.enableTourGuideAI);
  const tgaiPanelOpen = useMapStateStore((state) => state.tgaiPanelOpen);
  const setTgaiPanelOpen = useMapStateStore((state) => state.setTgaiPanelOpen);
  const showChatbotControl = enableTourGuideAI && platform === 'siteSee' && !isMobile;

  // Determine if controls should pulse based on active guide
  const isCoached = siteSeeGuideMode === 'tour';
  const pulseTarget = getPulseTarget(siteSeeGuideId, isMobile);
  const isPulsing = isCoached && pulseTarget === PULSE_TARGETS.CONTROLS;

  // Pass dims back to sitesee guide.
  // Hook returns a callback ref that triggers measurement when element mounts
  const mapControlsRef = useSiteSeeModalDims({ id: 'controls' });

  return (
    <div className="mapControls__wrapper">

      <div className="mapControls__innerWrapper">
        <SiteSeeTipTrigger siteSeeTipId="controls" />

        <div
          className={classNames('mapControls', {
            'mapControls--pulsing': isPulsing,
          })}
          ref={mapControlsRef}
        >
          <MapControlsZoomMore />
          <MapControlsZoomLess />
          <MapControlsZoomReset />
          <MapControlsMapTypeToggle />
          <MapControlsPOIToggle />
          <MapControlsMarkersToggle />
          {showChatbotControl && (
            <ChatbotControl
              isOpen={tgaiPanelOpen}
              setIsOpen={setTgaiPanelOpen}
            />
          )}
        </div>

        <VectreInfo />

      </div>
    </div>
  );
};

export default MapControls;
